import _ from "lodash";

type AnyObject = Record<string, any>;

const convertObjectKeys = (
  obj: AnyObject,
  converter: (key: string) => string,
): AnyObject => {
  if (_.isArray(obj)) {
    return obj.map((v) => convertObjectKeys(v, converter));
  } else if (_.isObject(obj) && !_.isFunction(obj)) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [converter(key)]: convertObjectKeys(obj[key], converter),
      }),
      {},
    );
  }
  return obj;
};

export const toSnakeCase = (obj: AnyObject): AnyObject => {
  return convertObjectKeys(obj, _.snakeCase);
};

export function toCamelCase<Type>(obj: AnyObject): Type {
  return convertObjectKeys(obj, _.camelCase) as Type;
}
